class ScrollTo {
    constructor(el, scrollTarget, clickTarget, eventName) {
        this.$el = el;
        this.$customEventName = eventName;
        this.$clickTarget = el.querySelector(clickTarget);
        this.$scrollTarget = el.querySelector(scrollTarget);
        if (this.$clickTarget) {
            this.$clickTarget.addEventListener('click', event => {
                event.preventDefault();
                this.scroll(this.$scrollTarget);
            });
        }
    }

    scroll(target) {
        if (!target) return;

        const trigger = target.querySelector('[aria-controls]');

        if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
            trigger.click();
        } else {
            this.dispatchEvent(
                new CustomEvent(this.$customEventName, {
                    detail: { target },
                    bubbles: true,
                    target: this,
                })
            );
        }

        setTimeout(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
    }

    dispatchEvent(event) {
        this.$el.dispatchEvent(event);
    }
}

export default ScrollTo;